    
    const validateAndSubmitNewsletterForm = (formId) => { 
        // Get form
        const form = document.querySelector(`#${formId}`);
        // Create boolean variable to track error
        let isError = false;
    
        // Create object to hold form data within
        const formData = {
            FNAME: form.querySelector('#mce-FNAME').value,
            EMAIL: form.querySelector('#mce-EMAIL').value,
            gdpr: form.querySelector('#gdpr-signup').checked
        }
    
        // Loop through object to check if element has a value
        for(const input in formData) {
            // Get the related error-p tag based on input ID
            const errorP =  form.querySelector(`#error-p__${input}`);
    
            // If input isn't gdpr as it's a different input type and value is empty
            if(input !== 'gdpr' && formData[input] === '') {
                // Show error-p element 
                errorP.classList.add('show-error');   
                // Set isErrors to true    
                isError = true;        
            } else if (input === 'gdpr' && !formData[input]){
                // If input is gdpr then check if it's not checked
                // If not then show error-p element
                errorP.classList.add('show-error');
            }else {
                // Hide error-p element if input has a value
                errorP.classList.remove('show-error');  
            }
        }
    
        // If there aren't any errors
        if(!isError) {
            // Find form submit butotn and simulate click to submit form
            const submitBtn = form.querySelector('#troxy-newsletter-submit');
            submitBtn.click();
        }
    
    }

    // HANDLING MAILCHIMP FORM SUCCESS RESONSE

    // Get contact form
    const form = document.querySelector('#mc-embedded-subscribe-form-newsletter');
   

    if(form) {
        // Get success element (Given by Mailchimp)
        const success = form.querySelector('#mce-success-response');
        // Create an observer instance to check a mutation in element
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                // If element has been mutated meaning success element has been filled
                if(mutation.type === 'attributes') {
                    // Find acting button 
                    const actingButton = document.querySelector('.troxy-newsletter-signup__acting-button');
                    // Hide form elements and acting button
                    form.classList.add('hide');
                    actingButton.style.display = 'none';
                    // Get thank you message and show within dom
                    const thankYouMsg = document.querySelector('#troxy-newsletter-signup-thank-you');
                    thankYouMsg.classList.add('show');
                    // Stop observing as mission has been completet
                    observer.disconnect();
                }   
            });
        });

        // Configuration of the observer
        var config = { attributes: true, childList: true, characterData: true }

        // Pass in the target node, as well as the observer options
        observer.observe(success, config);
    }